<md-menu
	[menuItems]="userMenuOptions"
	[triggerIcon]="{ type: 'material', icon: '' }"
	[popupPosition]="'bottom-end'"
	[popupClass]="'md-menu md-menu--user-header'"
>
	<!-- ─── Menu popup header: always shows the real logged-in user ─── -->
	<div md-menu-header class="user-menu-header">
		<lb-user-icon [userID]="headerUser().userID" class="user-menu-header__avatar"></lb-user-icon>
		<div class="user-menu-header__info">
			<span class="user-menu-header__name">{{ headerUser().name }}</span>
			<span class="user-menu-header__email">{{ headerUser().email }}</span>

			@if (headerUser().tzDisplay) {
				<div class="user-menu-header__tz">
					<span class="tz-row" [class.tz-row--warn]="headerUser().showTzWarning">
						<span class="tz-row__label">Timezone:</span>
						<span class="tz-row__value">{{ headerUser().tzDisplay }}</span>
					</span>
					@if (headerUser().showTzWarning) {
						<span class="tz-row tz-row--device">
							<span class="tz-row__label">Device:</span>
							<span class="tz-row__value">{{ headerUser().browserTzDisplay }}</span>
						</span>
					}
				</div>
			}
		</div>
	</div>

	<!-- ─── Impersonation: who you are acting as, and the way out ─── -->
	@if (impersonationView(); as imp) {
		<div md-menu-header class="user-switch-section">
			<span class="user-switch-section__title">{{ imp.sectionTitle }}</span>
			<ng-container *ngTemplateOutlet="impersonationCard; context: { $implicit: imp }"></ng-container>
		</div>
	}

	<!-- ─── Guardian / institution switch list ─── -->
	@if (showSwitchList()) {
		<div md-menu-header class="user-switch-section">
			<span class="user-switch-section__title">{{ switchListTitle() }}</span>

			@if (showSearch()) {
				<ng-container *ngTemplateOutlet="switchSearch"></ng-container>
			}

			<div class="user-switch-list" [class.user-switch-list--scrollable]="showSearch()" #switchList>
				@for (assocUser of filteredAssociatedUsers(); track assocUser.userID) {
					<ng-container *ngTemplateOutlet="userSwitchRow; context: { $implicit: assocUser }"></ng-container>
				}
				@if (filteredAssociatedUsers().length === 0) {
					<span class="user-switch-empty">No users found</span>
				}
			</div>
		</div>
	}

	<!-- ─── Trigger: avatar button ─── -->
	<div class="user-trigger-wrapper" [class.user-trigger-wrapper--stacked]="viewContext()?.isViewingOther">
		@if (viewContext(); as ctx) {
			<!-- All viewing-as modes: single avatar + badge overlay + name -->
			<div class="user-trigger__avatar-cluster">
				<lb-user-icon [userID]="ctx.primaryUserID" class="user-trigger__viewing-avatar"></lb-user-icon>
				<div class="user-trigger__viewing-badge" [class.user-trigger__viewing-badge--warn]="ctx.type === 'impersonating'">
					<md-icon class="user-trigger__badge-icon" icon="untitled-ui/users/users-02"></md-icon>
				</div>
				@if (currentTzAbbrev()) {
					<span class="tz-badge">{{ currentTzAbbrev() }}</span>
				}
			</div>
			<span class="user-trigger__viewing-name">{{ ctx.triggerLabel }}</span>
		} @else {
			<!-- Standard: own avatar -->
			<lb-user-icon [userID]="userID()"></lb-user-icon>
			@if (currentTzAbbrev()) {
				<span class="tz-badge" [class.tz-badge--warn]="headerUser().showTzWarning">
					@if (headerUser().showTzWarning) {
						<md-icon icon="untitled-ui/arrows/refresh-cw-02" class="tz-badge__icon"></md-icon>
					}
					{{ currentTzAbbrev() }}
				</span>
			}
		}
	</div>
</md-menu>

<!-- ─── Sub-templates ─── -->

<ng-template #impersonationCard let-ctx>
	<button type="button" class="user-impersonation-card" (click)="stopImpersonation()">
		<lb-user-icon [userID]="ctx.primaryUserID" class="user-impersonation-card__avatar"></lb-user-icon>
		<div class="user-impersonation-card__info">
			<span class="user-impersonation-card__name">{{ ctx.primaryFirstName }} {{ ctx.primaryLastName }}</span>
			<span class="user-impersonation-card__email">{{ ctx.primaryEmail }}</span>
			@if (ctx.primaryTzDisplay) {
				<div class="user-impersonation-card__tz">
					<span class="tz-row">
						<span class="tz-row__label">Timezone:</span>
						<span class="tz-row__value">{{ ctx.primaryTzDisplay }}</span>
					</span>
				</div>
			}
		</div>
		<md-icon icon="untitled-ui/general/x-close" class="user-impersonation-card__close"></md-icon>
	</button>
</ng-template>

<ng-template #userSwitchRow let-assocUser>
	<button
		type="button"
		class="user-switch-item"
		[class.user-switch-item--active]="assocUser.userID === viewingUserID()"
		[class.user-switch-item--no-enrollment]="assocUser.hasActiveEnrollment === false"
		(click)="handleSwitchUser(assocUser.userID)"
	>
		<lb-user-icon [userID]="assocUser.userID" class="user-switch-item__avatar"></lb-user-icon>
		<span class="user-switch-item__name">{{ assocUser.firstName }} {{ assocUser.lastName }}</span>
		@if (!assocUser.hasActiveEnrollment) {
			<md-icon icon="untitled-ui/users/user-x-02" class="user-switch-item__status-icon" md-tooltip="No active enrollment"></md-icon>
		}
		@if (assocUser.userID === viewingUserID()) {
			<md-icon icon="untitled-ui/general/check" class="user-switch-item__check"></md-icon>
		}
	</button>
</ng-template>

<ng-template #switchSearch>
	<div class="user-switch-search-wrapper">
		<md-icon icon="untitled-ui/general/search-sm" class="user-switch-search__icon"></md-icon>
		<input class="user-switch-search" type="text" placeholder="Search users…" [value]="institutionSearchTerm()" (input)="onSearchInput($event)" />
	</div>
</ng-template>
